import { useEffect, useState } from 'react'
import { useStyles } from './AiModalContent.styles'
import { Formik, Form } from 'formik'
import * as Yup from 'yup'
import { AutoComplete, MultiselectV2 } from '@labrav/react-components'
import {
  DataType,
  FormField,
} from '@labrav/react-components/lib/@types/types/forms'
import { useSelector as useSelectorState } from '../../../store'
import { Listingdata, Product } from '../../../modules/productsListing/types'
import { Options } from '@labrav/react-components/lib/@types/v2/components/AutoComplete'
import { isEmpty } from 'lodash'
import { SEO_CLOUD_MARKETPLACE } from '../seoCloud'

interface AiModalContentProps {
  handleSelectedListingData: (data: Product) => void
  handleGeneratButtonState: (value: boolean) => void
  handleSelectedSearchKeywords: (keywords: any) => void
  selectedListingProduct: Product
  selectedSearchKeyWords: any
}

const AiModalContent: React.FC<AiModalContentProps> = ({
  handleSelectedListingData,
  handleGeneratButtonState,
  handleSelectedSearchKeywords,
  selectedListingProduct,
  selectedSearchKeyWords,
}) => {
  const { classes } = useStyles()
  const [selectedListing, setSelectedListing] = useState(
    selectedListingProduct?.id || ''
  )
  const [searchKeyowdsSelected, setSearchKeywordsSelected] = useState(
    selectedSearchKeyWords || []
  )
  const cloudMarketplace = SEO_CLOUD_MARKETPLACE
  const productWithListingData = useSelectorState<Product[]>(
    state =>
      state.productsListing[cloudMarketplace]?.productWithListingData?.rows ||
      []
  )

  const validationSchema = Yup.object({
    listingName: Yup.string().nullable().required('Please select the product.'),
    keywords: Yup.array()
      .of(Yup.string().trim())
      .required('Search Keywords are required')
      .min(1, 'At least one keyword is required')
      .max(5, 'You can only add up to 5 keywords'),
  })
  const initialValues = {
    listingName: selectedListingProduct?.id || (null as string | null),
    keywords: selectedSearchKeyWords || [],
  }
  const productOptions: Options[] = productWithListingData
    .filter(product => product.productName && product.productType)
    .map(product => ({
      label: product.productName,
      key: product?.id ?? '',
    }))
  const selectedProductListingData = productWithListingData.find(
    product => selectedListing === product.id
  )
  if (selectedProductListingData) {
    handleSelectedListingData(selectedProductListingData)
    handleSelectedSearchKeywords(searchKeyowdsSelected)
  }

  const searchKeywords = (
    ((selectedProductListingData?.listingData as Listingdata)
      ?.searchKeywords as any) ||
    ((selectedProductListingData?.listingData as Listingdata)
      ?.searchKeyword as any)
  )?.value.split(',')
  const multiSelectField: FormField = {
    title: 'Enhance for upto 5 keywords',
    placeHolder: 'Enhance for upto 5 keywords',
    humanReadableKey: 'keywords',
    id: 'keywords',
    isRequired: true,
    isReadOnly: !selectedListing,
    isCustom: false,
    // defaultValue: true,
    dataType: 'multi_enum' as DataType,
    options: searchKeywords,
  }
  return (
    <Formik
      initialValues={initialValues}
      validateOnMount={true}
      validationSchema={validationSchema}
      enableReinitialize
      onSubmit={() => void 0}
    >
      {formikprops => {
        const {
          values,
          errors,
          touched,
          handleChange,
          handleBlur,
          isValid,
          dirty,
          handleSubmit,
          handleReset,
          setFieldValue,
        } = formikprops
        const handleSubmitModal = () => {}
        const selectedValue = values.listingName ? values.listingName : null
        const onChangeSelect = (event: any) => {
          const value = (event?.target?.value || '') as string
          setFieldValue('keywords', value)
          setSearchKeywordsSelected(value as any)
        }

        useEffect(() => {
          if (isEmpty(errors)) {
            handleGeneratButtonState(true)
          } else {
            handleGeneratButtonState(false)
          }
        }, [values, errors])
        const handleDelete = (value: string) => {
          const filteredOptions = [
            ...values.keywords.filter((option: any) => option !== value),
          ]
          setFieldValue('keywords', filteredOptions)
          setSearchKeywordsSelected(filteredOptions as any)
        }

        return (
          <Form onSubmit={handleSubmit} onReset={handleReset}>
            <div className={classes.autoCompleteWrapper}>
              {/* rest */}
              <AutoComplete
                id={'listingName'}
                label={'Select listing'}
                options={productOptions}
                value={
                  productOptions.find(
                    option => option.key === values.listingName
                  ) || null
                }
                onChange={(event, newValue) => {
                  if (typeof newValue === 'object') {
                    setFieldValue('listingName', newValue?.key)
                    setSelectedListing(newValue?.key as unknown as string)
                    setFieldValue('keywords', [])
                    setSearchKeywordsSelected([] as any)
                  }
                }}
                onBlur={handleBlur}
                error={touched.listingName && Boolean(errors.listingName)}
                helperText={
                  touched.listingName && (errors.listingName as string)
                }
              />
              <div>
                <MultiselectV2
                  field={multiSelectField}
                  onChangeSelect={onChangeSelect}
                  selectedValues={values.keywords}
                  handleDelete={handleDelete}
                  onBlur={handleBlur}
                  isError={touched.keywords && Boolean(errors.keywords)}
                  errorText={
                    (touched.keywords && (errors.keywords as string)) || ''
                  }
                />
              </div>
            </div>
          </Form>
        )
      }}
    </Formik>
  )
}

export default AiModalContent
